/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Parcel_RemovedInputs */

const vi_care_log_parcel_removed = /** @type {(inputs: Care_Log_Parcel_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng đã gỡ khỏi hộ`)
};

/**

* @param {Care_Log_Parcel_RemovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcel_removed = /** @type {((inputs?: Care_Log_Parcel_RemovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Parcel_RemovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcel_removed(inputs)
});